module.exports = __webpack_public_path__ + "img/name.599087df.png";